import React, { FC, useState } from "react";
import "./FavoriteItemModal.css";
import {axiosInstance} from "../../Auth/axiosInstance";
import { FavoriteItemModalProps } from "../ItemGridModel";

interface FavouriteItemConditionPrices {
  conditionID: number;
  conditionName: string;
  price: number | null;
}

const conditions: FavouriteItemConditionPrices[] = [
  { conditionID: 1, conditionName: "New", price: null },
  { conditionID: 2, conditionName: "New other (see details)", price: null },
  { conditionID: 3, conditionName: "Manufacturer refurbished", price: null },
  { conditionID: 4, conditionName: "Seller refurbished", price: null },
  { conditionID: 5, conditionName: "Used", price: null },
  { conditionID: 6, conditionName: "Very Good", price: null },
  { conditionID: 7, conditionName: "Acceptable", price: null },
  { conditionID: 8, conditionName: "For parts or not working", price: null },
];

const FavoriteItemModal: FC<FavoriteItemModalProps> = ({ title, currentPrice, isOpen, onClose }) => {
  const words = title.split(/\s+/); // Split title into words
  const [selectedWord, setSelectedWord] = useState<string>("");

  const [conditionPrices, setConditionPrices] = useState<FavouriteItemConditionPrices[]>(conditions);
  const [isSaving, setIsSaving] = useState(false);

  const handleWordChange = (word: string): void => {
    setSelectedWord(word);
  };

  const handlePriceChange = (conditionID: number, price: number | null): void => {
    setConditionPrices((prev) =>
      prev.map((condition) =>
        condition.conditionID === conditionID
          ? { ...condition, price }
          : condition
      )
    );
  };

  const handleSave = async (): Promise<void> => {
    if (!selectedWord) {
      alert("Please select a word.");
      return;
    }

    const payload = {
      name: selectedWord,
      conditionPrices,
    };

    setIsSaving(true);
    try {
      // Make API request to save favorite item
      await axiosInstance.post("filters/add-favorite-item", payload);
      alert(`Favorite item successfully saved: ${selectedWord}`);
      onClose(); // Close modal on successful save
    } catch (error) {
      console.error("Error saving favorite item:", error);
      alert("Failed to save favorite item. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Favorite Item</h3>
        <p>Select a word from the title:</p>
        <div className="word-list">
          {words.map((word) => (
            <label key={word}>
              <input
                type="radio"
                name="selectedWord"
                value={word}
                checked={selectedWord === word}
                onChange={() => handleWordChange(word)}
              />{" "}
              {word}
            </label>
          ))}
        </div>

        <div className="prices-section">
          <h4>Set Prices by Condition</h4>
          <p>Current Price: ${currentPrice}</p>
          {conditionPrices.map((condition) => (
            <div key={condition.conditionID} className="condition-row">
              <label>{condition.conditionName}</label>
              <input
                type="number"
                placeholder="Enter price"
                value={condition.price ?? ""}
                onChange={(e) =>
                  handlePriceChange(condition.conditionID, e.target.value ? parseFloat(e.target.value) : null)
                }
              />
            </div>
          ))}
        </div>

        <div className="modal-actions">
          <button className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn-save"
            onClick={handleSave}
            disabled={isSaving || !selectedWord}
          >
            {isSaving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FavoriteItemModal;
